import nengi from 'nengi'
import { uuid } from '../../utils/primitive-types'

class ItemFailedToListMessage {
	static protocol = {
		itemId: nengi.String,
	}
	itemId: uuid
	/**
	 * Creates an instance of ItemFailedToListMessage. This will scan the Stash to find a matching item.
	 * @param {uuid} itemId Item ID
	 * @memberof ItemFailedToListMessage
	 */
	constructor(itemId: uuid) {
		this.itemId = itemId
	}
}

export default ItemFailedToListMessage
